<template>
  <div class="catalogo-container">
    <!-- ===== NAVBAR ===== -->
    <nav class="navbar-custom">
      <div class="navbar-container">
        <div class="navbar-brand" @click="goHome">
          <img src="/jj.png" alt="SYSTEM JJ" class="navbar-logo" @error="handleLogoError" />
          <span class="navbar-title">SYSTEM JJ</span>
        </div>
        
        <div class="navbar-links">
          <button class="nav-link" @click="goHome">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0a1 1 0 01-1-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 01-1 1"/></svg>
            <span>Inicio</span>
          </button>
          <button class="nav-link active">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 7h-4.5A2.5 2.5 0 0013 9.5v5a2.5 2.5 0 01-2.5 2.5H4m16-8v8a2 2 0 01-2 2H6a2 2 0 01-2-2V7m16 0l-4-4M4 7l4-4"/></svg>
            <span>Productos</span>
          </button>
          <button class="nav-link" @click="goToServicios">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg>
            <span>Servicios</span>
          </button>
        </div>
        
        <div class="navbar-actions">
          <button class="cart-btn" @click="redirectToCart">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>
            <span class="cart-badge" v-if="cartItemCount > 0">{{ cartItemCount }}</span>
          </button>
        </div>
      </div>
    </nav>

    <!-- ===== HERO ===== -->
    <section class="catalogo-hero">
      <div class="hero-content">
        <h1>Catálogo de Productos</h1>
        <p>Busca por nombre, código o categoría</p>

        <div class="search-tools">
          <div class="search-box">
            <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input
              v-model="searchTerm"
              @input="handleSearch"
              @keyup.enter="handleSearch"
              placeholder="Ej: Laptop, Mouse, ABC123..."
              class="search-input"
              autocomplete="off"
            />
            <button v-if="searchTerm" @click="clearSearch" class="clear-search" type="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>

          <div class="category-filter">
            <select v-model="selectedCategory" @change="handleCategoryChange">
              <option value="all">Todas las categorías</option>
              <option v-for="cat in categories" :key="cat.idCategoria" :value="cat.idCategoria">
                {{ cat.nombre }}
              </option>
            </select>
          </div>

          <div class="currency-toggle premium">
            <button class="currency-btn" :class="{ active: !showBs }" @click="showBs = false; toggleCurrency()">
              <span>$</span>
              <span>USD</span>
            </button>
            
            <div class="currency-switch-container">
              <button class="switch-button" :class="{ 'bs-active': showBs }" @click="showBs = !showBs; toggleCurrency()">
                <div class="switch-slider">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 014-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 01-4 4H3"/></svg>
                </div>
              </button>
              <span class="bcv-badge" v-if="currentRate">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16"/><path d="M4 20h16"/><path d="M4 12h16"/></svg>
                BCV: {{ formatNumber(currentRate.precio_usd_bs) }}
              </span>
            </div>
            
            <button class="currency-btn" :class="{ active: showBs }" @click="showBs = true; toggleCurrency()">
              <span>Bs</span>
              <span>Bs</span>
            </button>
          </div>
        </div>

        <div class="payment-type-selector">
          <button class="payment-btn" :class="{ active: paymentType === 'cash' }" @click="paymentType = 'cash'">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
            <span>Contado</span>
          </button>
          <button class="payment-btn credit" :class="{ active: paymentType === 'credit' }" @click="paymentType = 'credit'">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/><line x1="8" y1="14" x2="16" y2="14"/></svg>
            <span>Cashea</span>
          </button>
          <div class="payment-info-tooltip">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
            <span class="tooltip-text">El precio de crédito (Cashea) incluye un recargo del 17% sobre el precio de contado</span>
          </div>
        </div>

        <div v-if="searchTerm || selectedCategory !== 'all'" class="search-results-info">
          <span v-if="searchTerm">Buscando: <strong>"{{ searchTerm }}"</strong></span>
          <span v-if="selectedCategory !== 'all'">Categoría: <strong>{{ getCategoryName(selectedCategory) }}</strong></span>
          <span class="results-count">{{ filteredProducts.length }} resultados</span>
        </div>
      </div>
    </section>

    <!-- ===== BANNER TASA ===== -->
    <div v-if="currentRate && showBs" class="rate-banner premium">
      <div class="rate-info">
        <div class="rate-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>
        </div>
        <div class="rate-details">
          <span class="rate-label">Tasa BCV del día</span>
          <span class="rate-value"><strong>{{ formatNumber(currentRate.precio_usd_bs) }} Bs/USD</strong></span>
          <span class="rate-date">{{ formatDate(currentRate.fecha) }}</span>
        </div>
        <button class="rate-refresh" @click="loadCurrentRate" title="Actualizar tasa">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/></svg>
        </button>
      </div>
    </div>

    <!-- ===== PRODUCTOS ===== -->
    <main class="catalogo-main">
      <div class="container">
        <div class="products-header">
          <div class="header-left">
            <h2>Productos <span class="product-count">{{ filteredProducts.length }}</span></h2>
            <div class="price-info" v-if="showBs">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
              <span>Precios convertidos a Bs con tasa BCV</span>
            </div>
          </div>
          
          <div class="header-right">
            <select v-model="sortBy" @change="sortProducts">
              <option value="nombre">Nombre</option>
              <option value="precioVenta_desc">Precio ↑</option>
              <option value="precioVenta">Precio ↓</option>
              <option value="codigo">Código</option>
              <option value="stock_desc">Stock ↑</option>
              <option value="stock">Stock ↓</option>
            </select>
          </div>
        </div>

        <div v-if="loading" class="loading">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="spinner"><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"/><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"/><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"/></svg>
          <p>Cargando productos...</p>
        </div>

        <div v-else-if="filteredProducts.length === 0" class="no-results">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          <h3>No se encontraron productos</h3>
          <p v-if="searchTerm">No hay resultados para "{{ searchTerm }}"</p>
          <p v-else-if="selectedCategory !== 'all'">No hay productos en esta categoría</p>
          <p v-else>Intenta con otros términos de búsqueda</p>
          <button v-if="searchTerm || selectedCategory !== 'all'" @click="clearAllFilters" class="btn-clear">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            Limpiar filtros
          </button>
        </div>

        <div v-else class="products-grid">
          <div
            v-for="product in paginatedProducts"
            :key="product.idProducto"
            class="product-card"
          >
            <div class="image-wrapper" @click="openImageViewer(product)">
              <div class="image-container">
                <img :src="getProductImage(product.imagen)" :alt="product.nombre" loading="lazy" />
              </div>
              <div class="image-overlay">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              </div>
              <span v-if="product.stock <= 0" class="badge out">Agotado</span>
              <span v-else-if="product.stock <= (product.stock_minimo || 0)" class="badge low">Últimas unidades</span>
            </div>

            <div class="product-info">
              <div class="category-badge" @click="filterByCategory(product.idCategoria)">
                {{ product.nombreCategoria || getCategoryName(product.idCategoria) }}
              </div>
              
              <h3 @click="openModal(product)">{{ product.nombre }}</h3>
              <p class="code" @click="openModal(product)">{{ product.codigo }}</p>

              <div class="price-section">
                <div class="price-main">
                  <div class="price-usd" v-if="!showBs">
                    {{ formatUSD(getDisplayPrice(product)) }}
                  </div>
                  <div class="price-bs" v-if="showBs">
                    {{ formatBs(getDisplayPrice(product)) }}
                  </div>
                </div>
                
                <div class="price-original" v-if="paymentType === 'credit'">
                  <span class="original-label">Contado:</span>
                  <span class="original-value">
                    {{ !showBs ? formatUSD(product.precio_venta_usd) : formatBs(product.precio_venta_usd) }}
                  </span>
                </div>
              </div>

              <div class="actions">
                <button class="btn-glow primary" @click.stop="addToCart(product)">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>
                    Comprar
                  </span>
                </button>
                <button class="btn-glass" @click.stop="openModal(product)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="totalPages > 1" class="pagination">
          <button class="btn-glass" @click="prevPage" :disabled="currentPage === 1">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
          </button>
          <span class="page-info">Página {{ currentPage }} / {{ totalPages }}</span>
          <button class="btn-glass" @click="nextPage" :disabled="currentPage === totalPages">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
          </button>
        </div>
      </div>
    </main>

    <!-- ===== MODAL PRODUCTO ===== -->
    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-card">
        <button class="close-btn" @click="closeModal">×</button>

        <div class="modal-content">
          <div class="modal-image" @click="openImageViewer(selectedProduct)">
            <div class="image-container">
              <img :src="getProductImage(selectedProduct.imagen)" :alt="selectedProduct.nombre" />
            </div>
            <div class="image-zoom-hint">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              Click para ampliar
            </div>
          </div>

          <div class="modal-info">
            <div class="modal-header">
              <div class="modal-category">
                {{ selectedProduct.nombreCategoria || getCategoryName(selectedProduct.idCategoria) }}
              </div>
              <h2>{{ selectedProduct.nombre }}</h2>
              <p class="modal-code">Código: {{ selectedProduct.codigo }}</p>
              <p class="modal-brand" v-if="selectedProduct.marca">Marca: {{ selectedProduct.marca }}</p>
              <p class="modal-model" v-if="selectedProduct.modelo">Modelo: {{ selectedProduct.modelo }}</p>
            </div>

            <div class="modal-price-section premium">
              <div class="price-comparison">
                <div class="price-card cash">
                  <div class="price-header">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
                    <span>Contado</span>
                    <span class="price-badge">Sin recargo</span>
                  </div>
                  <div class="price-amount">
                    <span class="currency-symbol">$</span>
                    <span class="price-value">{{ formatNumber(selectedProduct.precio_venta_usd) }}</span>
                    <span class="currency-label">USD</span>
                  </div>
                  <div class="price-amount-bs" v-if="showBs">
                    <span class="currency-symbol">Bs</span>
                    <span class="price-value">{{ formatBsNumber(selectedProduct.precio_venta_usd) }}</span>
                  </div>
                </div>
                
                <div class="price-divider">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                  <span>+17%</span>
                </div>
                
                <div class="price-card credit">
                  <div class="price-header">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/><line x1="8" y1="14" x2="16" y2="14"/></svg>
                    <span>Cashea</span>
                    <span class="price-badge">Recargo incluido</span>
                  </div>
                  <div class="price-amount">
                    <span class="currency-symbol">$</span>
                    <span class="price-value highlight">{{ formatNumber(getCreditPrice(selectedProduct)) }}</span>
                    <span class="currency-label">USD</span>
                  </div>
                  <div class="price-amount-bs" v-if="showBs">
                    <span class="currency-symbol">Bs</span>
                    <span class="price-value highlight">{{ formatBsNumber(getCreditPrice(selectedProduct)) }}</span>
                  </div>
                </div>
              </div>
              
              <div class="stock-info">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="21 8 21 21 3 21 3 8"/><rect x="1" y="3" width="22" height="5"/><line x1="10" y1="12" x2="14" y2="12"/></svg>
                <span>Stock disponible:</span>
                <strong :class="selectedProduct.stock <= 0 ? 'text-danger' : selectedProduct.stock <= (selectedProduct.stock_minimo || 0) ? 'text-warning' : 'text-success'">
                  {{ selectedProduct.stock <= 0 ? 'Agotado' : `${selectedProduct.stock} unidades` }}
                </strong>
                <span v-if="selectedProduct.stock_minimo" class="stock-minimo">(Mínimo: {{ selectedProduct.stock_minimo }})</span>
              </div>
            </div>

            <div class="modal-desc">
              <h4>Descripción</h4>
              <p>{{ selectedProduct.descripcion || 'Sin descripción disponible.' }}</p>
            </div>

            <div class="modal-garantia" v-if="selectedProduct.garantia_meses">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>
              <span>Garantía: {{ selectedProduct.garantia_meses }} {{ selectedProduct.garantia_meses === 1 ? 'mes' : 'meses' }}</span>
            </div>

            <button class="btn-glow primary big" @click="addToCart(selectedProduct)" :disabled="selectedProduct.stock <= 0">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>
                Agregar al carrito
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== VISOR DE IMAGEN ===== -->
    <div v-if="showImageViewer" class="image-viewer-overlay" @click.self="closeImageViewer">
      <button class="viewer-close" @click="closeImageViewer">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
      
      <div class="viewer-container">
        <div class="viewer-image-wrapper">
          <img :src="getProductImage(viewerImage)" :alt="viewerProductName" class="viewer-image" />
        </div>
        <div class="viewer-caption">
          <h3>{{ viewerProductName }}</h3>
          <p>{{ viewerProductCode }}</p>
        </div>
      </div>
      
      <button class="viewer-nav viewer-prev" @click="prevImage" v-if="hasMultipleImages">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
      </button>
      <button class="viewer-nav viewer-next" @click="nextImage" v-if="hasMultipleImages">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
      </button>
    </div>

    <!-- ===== FLOATING CART BUTTON ===== -->
    <button class="floating-cart-btn" @click="redirectToCart">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>
      <span class="cart-count" v-if="cartItemCount > 0">{{ cartItemCount }}</span>
    </button>

    <!-- ===== FOOTER ===== -->
    <footer class="footer-custom">
      <div class="footer-container">
        <div class="footer-brand">
          <img src="/jj.png" alt="SYSTEM JJ" class="footer-logo" @error="handleLogoError" />
          <div class="footer-info">
            <h3>SYSTEM JJ</h3>
            <p>Soluciones Tecnológicas</p>
          </div>
        </div>
        
        <div class="footer-links">
          <div class="footer-col">
            <h4>Enlaces</h4>
            <button @click="goHome">Inicio</button>
            <button @click="goToServicios">Servicios</button>
          </div>
          <div class="footer-col">
            <h4>Contacto</h4>
            <p>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></svg>
              0414-5146450
            </p>
            <p>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              soporte@systemjj.com
            </p>
          </div>
        </div>
        
        <div class="footer-bottom">
          <p>&copy; {{ new Date().getFullYear() }} SYSTEM JJ Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import {
  obtenerProductos,
  obtenerUrlImagen,
  ordenarProductos
} from '@/api/productos.js';
import { obtenerCategorias } from '@/api/categorias.js';
import { obtenerTasaVentaActual } from '@/api/tasaVenta.js';

export default {
  name: 'CatalogoProductos',

  data() {
    return {
      products: [],
      filteredProducts: [],
      paginatedProducts: [],
      loading: true,
      
      searchTerm: '',
      selectedCategory: 'all',
      categories: [],
      
      showBs: false,
      currentRate: null,
      
      paymentType: 'cash',
      
      sortBy: 'nombre',
      
      currentPage: 1,
      itemsPerPage: 12,
      
      showModal: false,
      selectedProduct: {},
      
      showImageViewer: false,
      viewerImage: '',
      viewerProductName: '',
      viewerProductCode: '',
      viewerImages: [],
      currentImageIndex: 0,
      
      cartItemCount: 0,
      cartItems: JSON.parse(localStorage.getItem('cart') || '[]'),
      
      searchTimeout: null
    };
  },

  computed: {
    totalPages() {
      return Math.ceil(this.filteredProducts.length / this.itemsPerPage);
    },
    
    hasMultipleImages() {
      return this.viewerImages.length > 1;
    }
  },

  watch: {
    cartItems: {
      handler(newItems) {
        this.cartItemCount = newItems.reduce((sum, item) => sum + item.quantity, 0);
        localStorage.setItem('cart', JSON.stringify(newItems));
      },
      deep: true
    }
  },

  async mounted() {
    await this.loadData();
    this.cartItemCount = this.cartItems.reduce((sum, item) => sum + item.quantity, 0);
    
    this.adjustItemsPerPage();
    window.addEventListener('resize', this.adjustItemsPerPage);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.adjustItemsPerPage);
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },

  methods: {
    goHome() {
      window.location.href = 'http://localhost:8080/';
    },
    
    goToServicios() {
      window.location.href = '/catalogo-servicios';
    },

    handleLogoError(e) {
      e.target.style.display = 'none';
    },

    redirectToCart() {
      window.location.href = 'http://localhost:8080/';
    },

    getCreditPrice(product) {
      const originalPrice = product.precio_venta_usd || 0;
      return originalPrice * 1.17;
    },
    
    getDisplayPrice(product) {
      if (this.paymentType === 'credit') {
        return this.getCreditPrice(product);
      }
      return product.precio_venta_usd || 0;
    },
    
    adjustItemsPerPage() {
      const width = window.innerWidth;
      if (width < 480) {
        this.itemsPerPage = 6;
      } else if (width < 768) {
        this.itemsPerPage = 8;
      } else if (width < 1024) {
        this.itemsPerPage = 9;
      } else {
        this.itemsPerPage = 12;
      }
      this.updatePagination();
    },

    async loadData() {
      this.loading = true;
      try {
        const productsResponse = await obtenerProductos('activos');
        if (productsResponse.success) {
          this.products = productsResponse.data;
          this.filteredProducts = [...this.products];
        }

        const categoriesResponse = await obtenerCategorias('activas');
        if (categoriesResponse.success) {
          this.categories = categoriesResponse.data;
        }

        const rateResponse = await obtenerTasaVentaActual();
        if (rateResponse.success) {
          this.currentRate = rateResponse.data;
        }

        this.sortProducts();
        this.updatePagination();
      } catch (error) {
        console.error('Error cargando datos:', error);
      }
      this.loading = false;
    },

    handleSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.applyFilters();
      }, 300);
    },

    handleCategoryChange() {
      this.applyFilters();
    },

    applyFilters() {
      let filtered = [...this.products];
      
      if (this.selectedCategory !== 'all') {
        filtered = filtered.filter(product => {
          const productCategoryId = String(product.idCategoria);
          const selectedCategoryId = String(this.selectedCategory);
          return productCategoryId === selectedCategoryId;
        });
      }
      
      if (this.searchTerm && this.searchTerm.trim() !== '') {
        const term = this.searchTerm.toLowerCase().trim();
        filtered = filtered.filter(product => {
          const nombre = (product.nombre || '').toLowerCase();
          const codigo = (product.codigo || '').toLowerCase();
          const categoria = (product.nombreCategoria || this.getCategoryName(product.idCategoria) || '').toLowerCase();
          const marca = (product.marca || '').toLowerCase();
          const modelo = (product.modelo || '').toLowerCase();
          
          return nombre.includes(term) || 
                 codigo.includes(term) || 
                 categoria.includes(term) ||
                 marca.includes(term) ||
                 modelo.includes(term);
        });
        filtered = this.sortSearchResults(filtered, term);
      }
      
      this.filteredProducts = filtered;
      this.currentPage = 1;
      this.sortProducts();
      this.updatePagination();
    },

    sortSearchResults(products, term) {
      return products.sort((a, b) => {
        const aNombre = (a.nombre || '').toLowerCase();
        const bNombre = (b.nombre || '').toLowerCase();
        const aCodigo = (a.codigo || '').toLowerCase();
        const bCodigo = (b.codigo || '').toLowerCase();
        
        if (aNombre === term && bNombre !== term) return -1;
        if (aNombre !== term && bNombre === term) return 1;
        if (aCodigo === term && bCodigo !== term) return -1;
        if (aCodigo !== term && bCodigo === term) return 1;
        
        const aStartsWith = aNombre.startsWith(term);
        const bStartsWith = bNombre.startsWith(term);
        if (aStartsWith && !bStartsWith) return -1;
        if (!aStartsWith && bStartsWith) return 1;
        
        return aNombre.localeCompare(bNombre);
      });
    },

    clearSearch() {
      this.searchTerm = '';
      this.applyFilters();
    },

    clearAllFilters() {
      this.searchTerm = '';
      this.selectedCategory = 'all';
      this.applyFilters();
    },

    filterByCategory(categoryId) {
      this.selectedCategory = String(categoryId);
      this.applyFilters();
    },

    sortProducts() {
      this.filteredProducts = ordenarProductos(this.filteredProducts, this.sortBy);
      this.updatePagination();
    },

    updatePagination() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      this.paginatedProducts = this.filteredProducts.slice(start, start + this.itemsPerPage);
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.updatePagination();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.updatePagination();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },

    openImageViewer(product) {
      this.viewerImage = product.imagen;
      this.viewerProductName = product.nombre;
      this.viewerProductCode = product.codigo;
      this.viewerImages = [product.imagen];
      this.currentImageIndex = 0;
      this.showImageViewer = true;
      document.body.style.overflow = 'hidden';
    },

    closeImageViewer() {
      this.showImageViewer = false;
      document.body.style.overflow = 'auto';
    },

    prevImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
        this.viewerImage = this.viewerImages[this.currentImageIndex];
      }
    },

    nextImage() {
      if (this.currentImageIndex < this.viewerImages.length - 1) {
        this.currentImageIndex++;
        this.viewerImage = this.viewerImages[this.currentImageIndex];
      }
    },

    formatUSD(value) {
      const n = Number(value || 0);
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(n);
    },

    formatBs(value) {
      if (!this.currentRate) return 'Bs 0,00';
      const n = Number(value || 0);
      const bsAmount = n * this.currentRate.precio_usd_bs;
      return new Intl.NumberFormat('es-VE', {
        style: 'currency',
        currency: 'VES',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(bsAmount).replace('VES', 'Bs');
    },

    formatBsNumber(value) {
      if (!this.currentRate) return '0,00';
      const n = Number(value || 0);
      const bsAmount = n * this.currentRate.precio_usd_bs;
      return new Intl.NumberFormat('es-VE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(bsAmount);
    },

    formatNumber(value) {
      return new Intl.NumberFormat('es-VE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value || 0);
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('es-VE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    },

    toggleCurrency() {
      if (this.showBs && !this.currentRate) {
        this.loadCurrentRate();
      }
    },

    async loadCurrentRate() {
      const response = await obtenerTasaVentaActual();
      if (response.success) {
        this.currentRate = response.data;
      }
    },

    getProductImage(img) {
      try {
        return obtenerUrlImagen(img);
      } catch {
        return 'https://placehold.co/600x400/0f172a/ffffff?text=Imagen+No+Disponible';
      }
    },

    getCategoryName(idCategoria) {
      const category = this.categories.find(cat => cat.idCategoria == idCategoria);
      return category ? category.nombre : 'Sin categoría';
    },

    openModal(product) {
      this.selectedProduct = product;
      this.showModal = true;
      document.body.style.overflow = 'hidden';
    },

    closeModal() {
      this.showModal = false;
      this.selectedProduct = {};
      document.body.style.overflow = 'auto';
    },

    addToCart(product) {
      if (product.stock <= 0) {
        this.showNotification('Producto agotado', 'error');
        return;
      }
      
      const existingItem = this.cartItems.find(item => item.id === product.idProducto);
      const priceToAdd = this.getDisplayPrice(product);
      
      if (existingItem) {
        existingItem.quantity += 1;
      } else {
        this.cartItems.push({
          id: product.idProducto,
          nombre: product.nombre,
          codigo: product.codigo,
          precio: priceToAdd,
          precioOriginal: product.precio_venta_usd,
          paymentType: this.paymentType,
          imagen: product.imagen,
          quantity: 1
        });
      }
      
      const paymentText = this.paymentType === 'credit' ? '(Precio Cashea +17%)' : '(Precio Contado)';
      this.showNotification(`${product.nombre} se agregó al carrito ${paymentText}`);
    },

    showNotification(message, type = 'success') {
      const notification = document.createElement('div');
      notification.className = `notification ${type}`;
      notification.innerHTML = `
        <span>${message}</span>
      `;
      
      notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: ${type === 'success' ? 'linear-gradient(135deg, #22c55e, #16a34a)' : 'linear-gradient(135deg, #ef4444, #dc2626)'};
        color: white;
        padding: 12px 20px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        gap: 10px;
        box-shadow: 0 5px 15px rgba(0,0,0,0.2);
        z-index: 99999;
        animation: slideIn 0.3s ease;
        max-width: 90%;
        font-size: ${window.innerWidth < 768 ? '14px' : '16px'};
      `;
      
      document.body.appendChild(notification);
      
      setTimeout(() => {
        notification.style.animation = 'slideOut 0.3s ease';
        setTimeout(() => {
          if (notification.parentNode) {
            document.body.removeChild(notification);
          }
        }, 300);
      }, 3000);
    }
  }
};
</script>

<style scoped>
/* ===== TODOS LOS ESTILOS ===== */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.catalogo-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  width: 100%;
  overflow-x: hidden;
}

/* ===== NAVBAR ===== */
.navbar-custom {
  background: linear-gradient(135deg, #020617, #0f172a, #1e3a8a);
  padding: 0.6rem 1rem;
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 2px solid #3b82f6;
}

.navbar-container {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.navbar-brand {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  cursor: pointer;
}

.navbar-logo {
  height: 35px;
  width: auto;
  border-radius: 8px;
}

@media (min-width: 768px) {
  .navbar-logo {
    height: 40px;
  }
}

.navbar-title {
  color: white;
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 0.5px;
}

@media (min-width: 768px) {
  .navbar-title {
    font-size: 1.2rem;
  }
}

.navbar-links {
  display: flex;
  gap: 0.3rem;
}

@media (min-width: 768px) {
  .navbar-links {
    gap: 0.5rem;
  }
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.4rem 0.7rem;
  border: none;
  border-radius: 30px;
  background: transparent;
  color: #94a3b8;
  font-weight: 500;
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

@media (min-width: 768px) {
  .nav-link {
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
    gap: 0.4rem;
  }
}

.nav-link:hover {
  background: rgba(255,255,255,0.1);
  color: white;
}

.nav-link.active {
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  color: white;
  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.4);
}

.nav-link svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

@media (min-width: 768px) {
  .nav-link svg {
    width: 18px;
    height: 18px;
  }
}

.navbar-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.cart-btn {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: rgba(255,255,255,0.1);
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 768px) {
  .cart-btn {
    width: 40px;
    height: 40px;
  }
}

.cart-btn:hover {
  background: rgba(255,255,255,0.2);
  transform: scale(1.05);
}

.cart-btn svg {
  width: 18px;
  height: 18px;
}

@media (min-width: 768px) {
  .cart-btn svg {
    width: 20px;
    height: 20px;
  }
}

.cart-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #ef4444;
  color: white;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 0.55rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

@media (min-width: 768px) {
  .cart-badge {
    width: 18px;
    height: 18px;
    font-size: 0.6rem;
  }
}

/* ===== HERO ===== */
.catalogo-hero {
  background: linear-gradient(135deg, #020617, #0f172a, #1e3a8a);
  color: white;
  padding: 1.5rem 1rem;
  text-align: center;
  width: 100%;
  position: relative;
  overflow: hidden;
}

@media (min-width: 768px) {
  .catalogo-hero {
    padding: 2.5rem 1rem;
  }
}

@media (min-width: 1024px) {
  .catalogo-hero {
    padding: 3.5rem 1rem;
  }
}

.catalogo-hero::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(59,130,246,0.1) 0%, transparent 70%);
  animation: rotate 30s linear infinite;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.hero-content {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  position: relative;
  z-index: 2;
}

.hero-content h1 {
  font-size: 1.5rem;
  margin-bottom: 0.3rem;
  background: linear-gradient(135deg, #60a5fa, #4ade80, #fbbf24);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradientShift 3s ease infinite;
  background-size: 200% 200%;
}

@media (min-width: 768px) {
  .hero-content h1 {
    font-size: 2.2rem;
  }
}

.hero-content > p {
  color: #cbd5e1;
  margin-bottom: 1rem;
  font-size: 0.85rem;
}

@media (min-width: 768px) {
  .hero-content > p {
    font-size: 1rem;
    margin-bottom: 1.5rem;
  }
}

.search-tools {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
}

@media (min-width: 768px) {
  .search-tools {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.8rem;
  }
}

.search-box {
  width: 100%;
  background: white;
  border-radius: 999px;
  padding: 0.5rem 0.8rem;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

@media (min-width: 768px) {
  .search-box {
    flex: 1;
    min-width: 250px;
    max-width: 400px;
    padding: 0.7rem 1.2rem;
  }
}

.search-box:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 8px 25px rgba(59, 130, 246, 0.3);
  transform: scale(1.02);
}

.search-icon {
  color: #64748b;
  flex-shrink: 0;
}

.search-input {
  border: none;
  outline: none;
  width: 100%;
  font-size: 0.85rem;
  background: transparent;
  color: #0f172a;
}

.search-input::placeholder {
  color: #94a3b8;
}

@media (min-width: 768px) {
  .search-input {
    font-size: 0.95rem;
  }
}

.clear-search {
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 0.2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.clear-search:hover {
  background: #f1f5f9;
  color: #475569;
  transform: rotate(90deg);
}

.category-filter {
  width: 100%;
}

@media (min-width: 768px) {
  .category-filter {
    width: auto;
    min-width: 180px;
  }
}

.category-filter select {
  width: 100%;
  padding: 0.6rem 0.8rem;
  border-radius: 12px;
  border: 2px solid #334155;
  background: #1e293b;
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.85rem;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.8rem center;
  background-size: 1.2rem;
}

@media (min-width: 768px) {
  .category-filter select {
    padding: 0.7rem 2rem 0.7rem 1rem;
    font-size: 0.95rem;
  }
}

.category-filter select:hover {
  border-color: #3b82f6;
  background-color: #2d3748;
}

.category-filter select option {
  background: #1e293b;
  color: white;
}

.currency-toggle.premium {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(10px);
  padding: 0.3rem;
  border-radius: 50px;
  border: 1px solid rgba(255,255,255,0.1);
  box-shadow: 0 4px 15px rgba(0,0,0,0.3);
  width: 100%;
  justify-content: center;
}

@media (min-width: 768px) {
  .currency-toggle.premium {
    width: auto;
    min-width: 340px;
    padding: 0.3rem 0.4rem;
  }
}

.currency-btn {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  padding: 0.4rem 0.8rem;
  border: none;
  border-radius: 40px;
  background: transparent;
  color: #94a3b8;
  font-weight: 600;
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

@media (min-width: 768px) {
  .currency-btn {
    padding: 0.5rem 1.2rem;
    font-size: 0.85rem;
    gap: 0.3rem;
  }
}

.currency-btn.active {
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  color: white;
  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.4);
  transform: scale(1.05);
}

.currency-btn:not(.active):hover {
  color: white;
  background: rgba(255,255,255,0.1);
}

.currency-switch-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.1rem;
  position: relative;
}

.switch-button {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(135deg, #334155, #1e293b);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
}

@media (min-width: 768px) {
  .switch-button {
    width: 42px;
    height: 42px;
  }
}

.switch-button.bs-active {
  background: linear-gradient(135deg, #f59e0b, #fbbf24);
  animation: pulse 2s infinite;
}

.switch-button.bs-active svg {
  color: #1e3a8a;
  transform: rotate(360deg);
}

.switch-button svg {
  width: 14px;
  height: 14px;
  color: #fbbf24;
  transition: all 0.3s ease;
}

@media (min-width: 768px) {
  .switch-button svg {
    width: 16px;
    height: 16px;
  }
}

.bcv-badge {
  font-size: 0.6rem;
  color: #fbbf24;
  background: rgba(0,0,0,0.3);
  padding: 0.1rem 0.4rem;
  border-radius: 20px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 0.2rem;
  border: 1px solid rgba(245, 158, 11, 0.3);
}

@media (min-width: 768px) {
  .bcv-badge {
    font-size: 0.7rem;
    padding: 0.2rem 0.6rem;
    position: absolute;
    top: -22px;
  }
}

.bcv-badge svg {
  width: 8px;
  height: 8px;
  color: #fbbf24;
}

.payment-type-selector {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 1rem;
  flex-wrap: wrap;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  padding: 0.5rem 1rem;
  border-radius: 60px;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}

@media (min-width: 768px) {
  .payment-type-selector {
    gap: 1rem;
    padding: 0.6rem 1.5rem;
  }
}

.payment-btn {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.4rem 0.8rem;
  border: none;
  border-radius: 40px;
  background: rgba(255, 255, 255, 0.1);
  color: #e2e8f0;
  font-weight: 600;
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

@media (min-width: 768px) {
  .payment-btn {
    padding: 0.6rem 1.2rem;
    font-size: 0.9rem;
    gap: 0.5rem;
  }
}

.payment-btn svg {
  width: 14px;
  height: 14px;
}

@media (min-width: 768px) {
  .payment-btn svg {
    width: 18px;
    height: 18px;
  }
}

.payment-btn.active {
  background: linear-gradient(135deg, #22c55e, #16a34a);
  color: white;
  box-shadow: 0 4px 15px rgba(34, 197, 94, 0.4);
  transform: scale(1.05);
}

.payment-btn.credit.active {
  background: linear-gradient(135deg, #8b5cf6, #a78bfa);
  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.4);
}

.payment-btn:not(.active):hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.payment-info-tooltip {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 0.2rem;
  cursor: help;
}

.payment-info-tooltip svg {
  width: 14px;
  height: 14px;
  color: #94a3b8;
}

@media (min-width: 768px) {
  .payment-info-tooltip svg {
    width: 16px;
    height: 16px;
  }
}

.payment-info-tooltip:hover svg {
  color: #fbbf24;
}

.tooltip-text {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #1e293b;
  color: white;
  padding: 0.4rem 0.8rem;
  border-radius: 8px;
  font-size: 0.65rem;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease;
  margin-bottom: 8px;
  z-index: 100;
  box-shadow: 0 4px 15px rgba(0,0,0,0.3);
}

@media (max-width: 480px) {
  .tooltip-text {
    white-space: normal;
    width: 180px;
    text-align: center;
  }
}

.tooltip-text::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: #1e293b transparent transparent transparent;
}

.payment-info-tooltip:hover .tooltip-text {
  opacity: 1;
  visibility: visible;
}

.search-results-info {
  margin-top: 0.8rem;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  color: #e2e8f0;
  font-size: 0.75rem;
  background: rgba(0,0,0,0.2);
  padding: 0.4rem 0.8rem;
  border-radius: 30px;
  backdrop-filter: blur(5px);
  display: inline-flex;
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
}

@media (min-width: 480px) {
  .search-results-info {
    flex-direction: row;
    gap: 0.8rem;
    font-size: 0.85rem;
    padding: 0.5rem 1rem;
  }
}

.results-count {
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  padding: 0.1rem 0.6rem;
  border-radius: 999px;
  font-weight: 600;
}

.rate-banner.premium {
  background: linear-gradient(135deg, #1e293b, #0f172a);
  padding: 0.6rem 0.8rem;
  border-bottom: 2px solid #3b82f6;
  position: relative;
  overflow: hidden;
}

@media (min-width: 768px) {
  .rate-banner.premium {
    padding: 0.8rem 1rem;
  }
}

.rate-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.rate-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 768px) {
  .rate-icon {
    width: 40px;
    height: 40px;
  }
}

.rate-icon svg {
  width: 16px;
  height: 16px;
}

@media (min-width: 768px) {
  .rate-icon svg {
    width: 20px;
    height: 20px;
  }
}

.rate-details {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
  background: rgba(255,255,255,0.1);
  padding: 0.3rem 0.8rem;
  border-radius: 30px;
  backdrop-filter: blur(5px);
}

@media (min-width: 768px) {
  .rate-details {
    gap: 0.8rem;
    padding: 0.5rem 1rem;
  }
}

.rate-label {
  color: #94a3b8;
  font-size: 0.7rem;
}

@media (min-width: 768px) {
  .rate-label {
    font-size: 0.85rem;
  }
}

.rate-value {
  color: #fbbf24;
  font-size: 0.9rem;
  font-weight: 700;
}

@media (min-width: 768px) {
  .rate-value {
    font-size: 1.1rem;
  }
}

.rate-date {
  color: #64748b;
  font-size: 0.65rem;
  padding-left: 0.3rem;
  border-left: 1px solid #334155;
}

@media (min-width: 768px) {
  .rate-date {
    font-size: 0.8rem;
    padding-left: 0.5rem;
  }
}

.rate-refresh {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  background: rgba(255,255,255,0.1);
  color: #94a3b8;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

@media (min-width: 768px) {
  .rate-refresh {
    width: 36px;
    height: 36px;
  }
}

.rate-refresh:hover {
  background: #3b82f6;
  color: white;
  transform: rotate(180deg);
}

.rate-refresh svg {
  width: 14px;
  height: 14px;
}

@media (min-width: 768px) {
  .rate-refresh svg {
    width: 16px;
    height: 16px;
  }
}

/* ===== PRODUCTOS ===== */
.container {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 0.8rem;
}

@media (min-width: 640px) {
  .container {
    padding: 0 1.2rem;
  }
}

@media (min-width: 1024px) {
  .container {
    padding: 0 2rem;
  }
}

.products-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.8rem;
  margin: 1rem 0;
}

@media (min-width: 640px) {
  .products-header {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}

.header-left h2 {
  font-size: 1.2rem;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
}

@media (min-width: 768px) {
  .header-left h2 {
    font-size: 1.6rem;
  }
}

.product-count {
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  color: white;
  padding: 0.1rem 0.5rem;
  border-radius: 20px;
  font-size: 0.75rem;
}

@media (min-width: 768px) {
  .product-count {
    font-size: 0.9rem;
    padding: 0.2rem 0.6rem;
  }
}

.price-info {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  color: #475569;
  font-size: 0.65rem;
  flex-wrap: wrap;
  background: #f1f5f9;
  padding: 0.2rem 0.6rem;
  border-radius: 20px;
}

@media (min-width: 768px) {
  .price-info {
    font-size: 0.8rem;
    padding: 0.3rem 0.8rem;
  }
}

.price-info svg {
  width: 12px;
  height: 12px;
}

@media (min-width: 768px) {
  .price-info svg {
    width: 14px;
    height: 14px;
  }
}

.header-right {
  width: 100%;
}

@media (min-width: 640px) {
  .header-right {
    width: auto;
  }
}

.header-right select {
  width: 100%;
  padding: 0.4rem 0.8rem;
  border-radius: 10px;
  border: 2px solid #cbd5e1;
  background: white;
  color: #334155;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.8rem;
}

@media (min-width: 640px) {
  .header-right select {
    width: auto;
    min-width: 130px;
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
  }
}

.header-right select:hover {
  border-color: #3b82f6;
}

/* ===== GRID DE PRODUCTOS ===== */
.products-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.8rem;
  width: 100%;
}

@media (min-width: 480px) {
  .products-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
}

@media (min-width: 768px) {
  .products-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 1.2rem;
  }
}

@media (min-width: 1024px) {
  .products-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 1.5rem;
  }
}

.product-card {
  background: white;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
}

@media (min-width: 768px) {
  .product-card {
    border-radius: 16px;
  }
}

.product-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(37, 99, 235, 0.12);
}

.product-card::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #2563eb, #3b82f6, #60a5fa);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.product-card:hover::after {
  transform: scaleX(1);
}

.image-wrapper {
  position: relative;
  height: 130px;
  overflow: hidden;
  cursor: pointer;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 480px) {
  .image-wrapper {
    height: 150px;
  }
}

@media (min-width: 768px) {
  .image-wrapper {
    height: 180px;
  }
}

@media (min-width: 1024px) {
  .image-wrapper {
    height: 200px;
  }
}

.image-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-wrapper img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  transition: transform 0.5s ease;
}

.product-card:hover .image-wrapper img {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-overlay svg {
  color: white;
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  padding: 8px;
  border-radius: 50%;
  transform: scale(0.5);
  transition: transform 0.3s ease;
}

@media (min-width: 768px) {
  .image-overlay svg {
    width: 40px;
    height: 40px;
    padding: 10px;
  }
}

.image-wrapper:hover .image-overlay {
  opacity: 1;
}

.image-wrapper:hover .image-overlay svg {
  transform: scale(1);
}

.badge {
  position: absolute;
  top: 6px;
  right: 6px;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 0.55rem;
  font-weight: 600;
  color: white;
  z-index: 2;
}

@media (min-width: 768px) {
  .badge {
    top: 10px;
    right: 10px;
    padding: 3px 10px;
    font-size: 0.65rem;
  }
}

.badge.out {
  background: #ef4444;
  animation: pulse 2s infinite;
}

.badge.low {
  background: #f59e0b;
}

.category-badge {
  display: inline-block;
  background: #dbeafe;
  color: #1e40af;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.55rem;
  font-weight: 600;
  margin-bottom: 0.3rem;
  cursor: pointer;
  transition: all 0.2s ease;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (min-width: 768px) {
  .category-badge {
    padding: 3px 10px;
    font-size: 0.7rem;
    border-radius: 12px;
    margin-bottom: 0.5rem;
  }
}

.category-badge:hover {
  background: #3b82f6;
  color: white;
  transform: scale(1.05);
}

.product-info {
  padding: 0.6rem;
  flex: 1;
  display: flex;
  flex-direction: column;
}

@media (min-width: 768px) {
  .product-info {
    padding: 1rem;
  }
}

.product-info h3 {
  font-size: 0.8rem;
  color: #0f172a;
  margin: 0.1rem 0;
  line-height: 1.3;
  flex: 1;
  cursor: pointer;
  transition: color 0.2s ease;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

@media (min-width: 768px) {
  .product-info h3 {
    font-size: 1rem;
    margin: 0.2rem 0;
  }
}

.product-info h3:hover {
  color: #3b82f6;
}

.code {
  color: #64748b;
  font-size: 0.6rem;
  margin: 0.1rem 0 0.3rem;
  cursor: pointer;
}

@media (min-width: 768px) {
  .code {
    font-size: 0.75rem;
    margin: 0.2rem 0 0.6rem;
  }
}

.price-section {
  margin: 0.3rem 0;
}

@media (min-width: 768px) {
  .price-section {
    margin: 0.6rem 0;
  }
}

.price-main .price-usd,
.price-main .price-bs {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 0.1rem;
}

@media (min-width: 768px) {
  .price-main .price-usd,
  .price-main .price-bs {
    font-size: 1.3rem;
  }
}

.price-main .price-usd {
  color: #059669;
}

.price-main .price-bs {
  color: #dc2626;
  animation: glow 2s ease-in-out infinite;
}

.price-original {
  font-size: 0.6rem;
  display: flex;
  align-items: center;
  gap: 0.2rem;
  flex-wrap: wrap;
  background: #f1f5f9;
  padding: 0.1rem 0.4rem;
  border-radius: 20px;
  width: fit-content;
  margin-top: 0.1rem;
}

@media (min-width: 768px) {
  .price-original {
    font-size: 0.75rem;
    padding: 0.2rem 0.6rem;
  }
}

.original-label {
  color: #475569;
  font-weight: 500;
}

.original-value {
  color: #94a3b8;
  text-decoration: line-through;
  font-weight: 500;
}

.actions {
  display: flex;
  gap: 0.3rem;
  margin-top: 0.3rem;
}

@media (min-width: 768px) {
  .actions {
    gap: 0.5rem;
    margin-top: 0.6rem;
  }
}

.btn-glow {
  position: relative;
  border: none;
  border-radius: 8px;
  padding: 0.4rem 0.5rem;
  cursor: pointer;
  overflow: hidden;
  font-weight: 600;
  color: white;
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  transition: all 0.3s ease;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  font-size: 0.6rem;
}

@media (min-width: 768px) {
  .btn-glow {
    border-radius: 10px;
    padding: 0.6rem 1rem;
    gap: 0.4rem;
    font-size: 0.8rem;
  }
}

.btn-glow svg {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

@media (min-width: 768px) {
  .btn-glow svg {
    width: 14px;
    height: 14px;
  }
}

.btn-glow::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s ease;
}

.btn-glow:hover::before {
  left: 100%;
}

.btn-glow:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.3);
}

.btn-glass {
  border-radius: 8px;
  padding: 0.4rem;
  border: none;
  background: rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(6px);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
}

@media (min-width: 768px) {
  .btn-glass {
    border-radius: 10px;
    padding: 0.6rem;
    min-width: 36px;
  }
}

.btn-glass svg {
  width: 14px;
  height: 14px;
  color: #64748b;
}

@media (min-width: 768px) {
  .btn-glass svg {
    width: 18px;
    height: 18px;
  }
}

.btn-glass:hover {
  background: rgba(37, 99, 235, 0.1);
  transform: scale(1.1);
}

.btn-glass:hover svg {
  color: #2563eb;
}

.btn-glow.big {
  width: 100%;
  margin-top: 0.8rem;
  padding: 0.6rem;
  font-size: 0.8rem;
}

@media (min-width: 768px) {
  .btn-glow.big {
    margin-top: 1.2rem;
    padding: 0.8rem;
    font-size: 0.95rem;
  }
}

.btn-glow:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ===== MODAL ===== */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(2, 6, 23, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 0.5rem;
  backdrop-filter: blur(5px);
}

.modal-card {
  background: white;
  border-radius: 16px;
  max-width: 95%;
  width: 100%;
  max-height: 95vh;
  overflow-y: auto;
  position: relative;
  animation: modalPop 0.3s ease;
}

@media (min-width: 768px) {
  .modal-card {
    border-radius: 20px;
    max-width: 900px;
    max-height: 90vh;
  }
}

.modal-content {
  display: flex;
  flex-direction: column;
  padding: 0.8rem;
}

@media (min-width: 768px) {
  .modal-content {
    flex-direction: row;
    gap: 1.5rem;
    padding: 1.5rem;
  }
}

.modal-image {
  position: relative;
  width: 100%;
  height: 180px;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 0.8rem;
  cursor: pointer;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 768px) {
  .modal-image {
    flex: 1;
    height: auto;
    min-height: 260px;
    margin-bottom: 0;
    border-radius: 14px;
  }
}

.modal-image .image-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-image img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.image-zoom-hint {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: rgba(0,0,0,0.6);
  color: white;
  padding: 3px 6px;
  border-radius: 20px;
  font-size: 0.6rem;
  display: flex;
  align-items: center;
  gap: 3px;
  backdrop-filter: blur(4px);
}

.image-zoom-hint svg {
  width: 10px;
  height: 10px;
}

.modal-info {
  flex: 1;
}

.modal-header h2 {
  font-size: 1.1rem;
  color: #0f172a;
  margin-bottom: 0.2rem;
}

@media (min-width: 768px) {
  .modal-header h2 {
    font-size: 1.6rem;
  }
}

.modal-category {
  display: inline-block;
  background: #dbeafe;
  color: #1e40af;
  padding: 0.1rem 0.6rem;
  border-radius: 20px;
  font-size: 0.6rem;
  font-weight: 600;
  margin-bottom: 0.3rem;
}

@media (min-width: 768px) {
  .modal-category {
    font-size: 0.7rem;
    padding: 0.2rem 0.8rem;
  }
}

.modal-code {
  color: #64748b;
  font-size: 0.7rem;
  margin: 0.2rem 0;
}

.modal-brand, .modal-model {
  color: #475569;
  font-size: 0.7rem;
  margin: 0.1rem 0;
}

.close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  background: rgba(0,0,0,0.1);
  color: #334155;
  font-size: 1.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10;
}

@media (min-width: 768px) {
  .close-btn {
    top: 12px;
    right: 12px;
    width: 36px;
    height: 36px;
    font-size: 1.5rem;
  }
}

.close-btn:hover {
  background: #ef4444;
  color: white;
  transform: rotate(90deg);
}

.modal-price-section.premium {
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  border-radius: 14px;
  padding: 0.8rem;
  margin: 0.8rem 0;
}

@media (min-width: 768px) {
  .modal-price-section.premium {
    padding: 1.2rem;
    margin: 1rem 0;
  }
}

.price-comparison {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-bottom: 0.8rem;
}

@media (min-width: 640px) {
  .price-comparison {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

.price-card {
  flex: 1;
  background: white;
  border-radius: 12px;
  padding: 0.6rem;
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
}

@media (min-width: 768px) {
  .price-card {
    padding: 1rem;
  }
}

.price-card.cash {
  border-left: 4px solid #22c55e;
}

.price-card.credit {
  border-left: 4px solid #8b5cf6;
  background: linear-gradient(135deg, #ffffff, #faf5ff);
}

.price-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  margin-bottom: 0.4rem;
  font-weight: 600;
  color: #334155;
  font-size: 0.7rem;
}

@media (min-width: 768px) {
  .price-header {
    font-size: 0.85rem;
    gap: 0.5rem;
    margin-bottom: 0.6rem;
  }
}

.price-header svg {
  width: 14px;
  height: 14px;
}

@media (min-width: 768px) {
  .price-header svg {
    width: 18px;
    height: 18px;
  }
}

.price-badge {
  font-size: 0.5rem;
  background: #f1f5f9;
  padding: 0.1rem 0.4rem;
  border-radius: 20px;
  color: #475569;
}

@media (min-width: 768px) {
  .price-badge {
    font-size: 0.6rem;
    padding: 0.2rem 0.5rem;
  }
}

.price-amount {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0.1rem;
  margin: 0.3rem 0;
}

.currency-symbol {
  font-size: 0.8rem;
  font-weight: 600;
  color: #64748b;
}

@media (min-width: 768px) {
  .currency-symbol {
    font-size: 1rem;
  }
}

.price-value {
  font-size: 1.3rem;
  font-weight: 800;
  color: #0f172a;
}

@media (min-width: 768px) {
  .price-value {
    font-size: 1.6rem;
  }
}

.price-value.highlight {
  background: linear-gradient(135deg, #8b5cf6, #a78bfa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.currency-label {
  font-size: 0.6rem;
  color: #94a3b8;
  font-weight: 500;
}

@media (min-width: 768px) {
  .currency-label {
    font-size: 0.7rem;
  }
}

.price-amount-bs {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0.1rem;
  margin-top: 0.1rem;
  font-size: 0.75rem;
}

@media (min-width: 768px) {
  .price-amount-bs {
    font-size: 0.9rem;
    margin-top: 0.3rem;
  }
}

.price-amount-bs .currency-symbol {
  font-size: 0.65rem;
}

@media (min-width: 768px) {
  .price-amount-bs .currency-symbol {
    font-size: 0.8rem;
  }
}

.price-amount-bs .price-value {
  font-size: 0.9rem;
}

@media (min-width: 768px) {
  .price-amount-bs .price-value {
    font-size: 1.2rem;
  }
}

.price-divider {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.3rem;
  color: #8b5cf6;
  font-weight: bold;
  font-size: 0.75rem;
}

@media (min-width: 640px) {
  .price-divider {
    flex-direction: row;
    gap: 0.3rem;
    padding: 0 0.5rem;
  }
}

.price-divider svg {
  width: 14px;
  height: 14px;
}

.stock-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  padding-top: 0.6rem;
  margin-top: 0.3rem;
  border-top: 1px solid #e2e8f0;
  font-size: 0.75rem;
  flex-wrap: wrap;
}

@media (min-width: 768px) {
  .stock-info {
    font-size: 0.9rem;
    gap: 0.5rem;
    padding-top: 1rem;
    margin-top: 0.5rem;
  }
}

.stock-info svg {
  width: 14px;
  height: 14px;
}

@media (min-width: 768px) {
  .stock-info svg {
    width: 16px;
    height: 16px;
  }
}

.stock-minimo {
  font-size: 0.6rem;
  color: #64748b;
  background: #f1f5f9;
  padding: 0.1rem 0.3rem;
  border-radius: 10px;
}

@media (min-width: 768px) {
  .stock-minimo {
    font-size: 0.7rem;
    padding: 0.1rem 0.4rem;
  }
}

.text-success { color: #22c55e; }
.text-warning { color: #f59e0b; }
.text-danger { color: #ef4444; }

.modal-garantia {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin: 0.6rem 0;
  padding: 0.3rem 0.6rem;
  background: #f1f5f9;
  border-radius: 10px;
  color: #1e40af;
  font-size: 0.75rem;
}

@media (min-width: 768px) {
  .modal-garantia {
    gap: 0.5rem;
    margin: 1rem 0;
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
  }
}

.modal-garantia svg {
  width: 14px;
  height: 14px;
}

@media (min-width: 768px) {
  .modal-garantia svg {
    width: 16px;
    height: 16px;
  }
}

/* ===== PAGINACIÓN ===== */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin: 1.5rem 0;
  flex-wrap: wrap;
}

@media (min-width: 768px) {
  .pagination {
    gap: 1rem;
    margin: 2.5rem 0;
  }
}

.page-info {
  color: #475569;
  font-weight: 500;
  font-size: 0.8rem;
  background: white;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

@media (min-width: 768px) {
  .page-info {
    font-size: 0.95rem;
    padding: 0.5rem 1.2rem;
  }
}

/* ===== LOADING / NO RESULTS ===== */
.loading, .no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  text-align: center;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
}

@media (min-width: 768px) {
  .loading, .no-results {
    padding: 3rem 1rem;
  }
}

.loading svg {
  width: 36px;
  height: 36px;
  color: #3b82f6;
  margin-bottom: 0.8rem;
  animation: spin 1s linear infinite;
}

@media (min-width: 768px) {
  .loading svg {
    width: 48px;
    height: 48px;
    margin-bottom: 1rem;
  }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.loading p {
  color: #64748b;
  font-size: 0.9rem;
}

@media (min-width: 768px) {
  .loading p {
    font-size: 1.1rem;
  }
}

.no-results svg {
  width: 40px;
  height: 40px;
  color: #94a3b8;
  margin-bottom: 0.8rem;
}

@media (min-width: 768px) {
  .no-results svg {
    width: 56px;
    height: 56px;
  }
}

.no-results h3 {
  color: #334155;
  font-size: 1.1rem;
  margin-bottom: 0.3rem;
}

@media (min-width: 768px) {
  .no-results h3 {
    font-size: 1.4rem;
  }
}

.no-results p {
  color: #94a3b8;
  font-size: 0.85rem;
}

.btn-clear {
  margin-top: 0.8rem;
  padding: 0.4rem 0.8rem;
  border: 2px solid #3b82f6;
  background: transparent;
  color: #3b82f6;
  border-radius: 30px;
  cursor: pointer;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  transition: all 0.3s ease;
  font-size: 0.8rem;
}

@media (min-width: 768px) {
  .btn-clear {
    padding: 0.5rem 1.2rem;
    font-size: 0.95rem;
    gap: 0.5rem;
  }
}

.btn-clear:hover {
  background: #3b82f6;
  color: white;
  transform: scale(1.05);
}

.btn-clear svg {
  width: 12px;
  height: 12px;
}

/* ===== FOOTER ===== */
.footer-custom {
  background: linear-gradient(135deg, #020617, #0f172a, #1e3a8a);
  color: #94a3b8;
  padding: 1.5rem 1rem;
  margin-top: 1.5rem;
  border-top: 2px solid #3b82f6;
}

@media (min-width: 768px) {
  .footer-custom {
    padding: 2rem 1rem;
    margin-top: 2rem;
  }
}

.footer-container {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
}

@media (min-width: 768px) {
  .footer-container {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }
}

.footer-brand {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.footer-logo {
  height: 40px;
  width: auto;
  border-radius: 8px;
}

@media (min-width: 768px) {
  .footer-logo {
    height: 50px;
  }
}

.footer-info h3 {
  color: white;
  font-size: 1rem;
  margin-bottom: 0.1rem;
}

@media (min-width: 768px) {
  .footer-info h3 {
    font-size: 1.2rem;
  }
}

.footer-info p {
  font-size: 0.8rem;
  color: #94a3b8;
}

.footer-links {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.footer-col h4 {
  color: white;
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
}

@media (min-width: 768px) {
  .footer-col h4 {
    font-size: 1rem;
  }
}

.footer-col button {
  display: block;
  background: none;
  border: none;
  color: #94a3b8;
  padding: 0.2rem 0;
  cursor: pointer;
  font-size: 0.75rem;
  transition: color 0.3s ease;
  text-align: left;
}

@media (min-width: 768px) {
  .footer-col button {
    font-size: 0.85rem;
    padding: 0.3rem 0;
  }
}

.footer-col button:hover {
  color: #60a5fa;
}

.footer-col p {
  font-size: 0.75rem;
  margin: 0.2rem 0;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

@media (min-width: 768px) {
  .footer-col p {
    font-size: 0.85rem;
    gap: 0.5rem;
    margin: 0.3rem 0;
  }
}

.footer-col p svg {
  width: 12px;
  height: 12px;
  color: #3b82f6;
  flex-shrink: 0;
}

@media (min-width: 768px) {
  .footer-col p svg {
    width: 14px;
    height: 14px;
  }
}

.footer-bottom {
  grid-column: 1 / -1;
  text-align: center;
  padding-top: 0.8rem;
  border-top: 1px solid #1e293b;
  font-size: 0.7rem;
  color: #64748b;
}

@media (min-width: 768px) {
  .footer-bottom {
    font-size: 0.8rem;
    padding-top: 1rem;
  }
}

/* ===== FLOATING CART ===== */
.floating-cart-btn {
  position: fixed;
  bottom: 16px;
  right: 16px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  border: none;
  color: white;
  cursor: pointer;
  box-shadow: 0 8px 25px rgba(37, 99, 235, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  transition: all 0.3s ease;
}

@media (min-width: 768px) {
  .floating-cart-btn {
    bottom: 24px;
    right: 24px;
    width: 52px;
    height: 52px;
  }
}

.floating-cart-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 12px 30px rgba(37, 99, 235, 0.5);
}

.floating-cart-btn svg {
  width: 20px;
  height: 20px;
}

@media (min-width: 768px) {
  .floating-cart-btn svg {
    width: 24px;
    height: 24px;
  }
}

.cart-count {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #ef4444;
  color: white;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 0.55rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  animation: pulse 2s infinite;
}

@media (min-width: 768px) {
  .cart-count {
    width: 22px;
    height: 22px;
    font-size: 0.65rem;
    top: -6px;
    right: -6px;
  }
}

/* ===== IMAGE VIEWER ===== */
.image-viewer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.98);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.8rem;
}

.viewer-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: rgba(255,255,255,0.2);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
  transition: all 0.3s ease;
}

@media (min-width: 768px) {
  .viewer-close {
    top: 24px;
    right: 24px;
    width: 44px;
    height: 44px;
  }
}

.viewer-close svg {
  width: 18px;
  height: 18px;
}

@media (min-width: 768px) {
  .viewer-close svg {
    width: 24px;
    height: 24px;
  }
}

.viewer-close:hover {
  background: #ef4444;
  transform: rotate(90deg);
}

.viewer-container {
  max-width: 100%;
  max-height: 90vh;
  position: relative;
}

.viewer-image-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.viewer-image {
  max-width: 100%;
  max-height: 80vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.5);
}

.viewer-caption {
  position: absolute;
  bottom: -40px;
  left: 0;
  right: 0;
  text-align: center;
  color: white;
  background: rgba(0,0,0,0.5);
  padding: 0.5rem;
  border-radius: 8px;
  font-size: 0.8rem;
  backdrop-filter: blur(5px);
}

@media (min-width: 768px) {
  .viewer-caption {
    bottom: -56px;
    padding: 0.8rem;
    font-size: 0.95rem;
  }
}

.viewer-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: rgba(255,255,255,0.2);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

@media (min-width: 768px) {
  .viewer-nav {
    width: 44px;
    height: 44px;
  }
}

.viewer-nav:hover {
  background: rgba(59,130,246,0.8);
  transform: translateY(-50%) scale(1.1);
}

.viewer-nav svg {
  width: 16px;
  height: 16px;
}

@media (min-width: 768px) {
  .viewer-nav svg {
    width: 20px;
    height: 20px;
  }
}

.viewer-prev { left: 8px; }
.viewer-next { right: 8px; }

@media (min-width: 768px) {
  .viewer-prev { left: 20px; }
  .viewer-next { right: 20px; }
}

/* ===== ANIMACIONES ===== */
@keyframes gradientShift {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

@keyframes modalPop {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
}

@keyframes glow {
  0%, 100% { text-shadow: 0 0 5px rgba(220,38,38,0.3); }
  50% { text-shadow: 0 0 15px rgba(220,38,38,0.5); }
}

.notification {
  position: fixed;
  top: 16px;
  right: 16px;
  padding: 10px 16px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  z-index: 99999;
  animation: slideIn 0.3s ease;
  max-width: 90%;
  font-size: 0.85rem;
}

@media (min-width: 768px) {
  .notification {
    top: 20px;
    right: 20px;
    padding: 12px 20px;
    font-size: 0.95rem;
    gap: 10px;
  }
}

.notification.success {
  background: linear-gradient(135deg, #22c55e, #16a34a);
  color: white;
}

.notification.error {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white;
}
</style>